"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationStyled = void 0;

var _utils = require("../../utils");

var _const = require("../../const");

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NotificationStyled = (0, _utils.styled)('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-height: 48px;\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: 15px 15px 15px 60px;\n  text-align: right;\n  & > svg {\n    width: 60px;\n    height: 48px;\n    display: block;\n    position: absolute;\n    text-align: center;\n    padding: 15px;\n    margin: -24px 0 0;\n    box-sizing: border-box;\n    top: 50%;\n    left: 0;\n  }\n  span {\n    text-align: left;\n    display: block;\n    word-break: break-word;\n  }\n  button,\n  a {\n    background-color: transparent;\n    color: ", ";\n    font-size: ", ";\n    font-weight: bold;\n    text-align: center;\n    text-transform: uppercase;\n    display: block;\n    line-height: 20px;\n    padding: 14px 15px;\n    border: none;\n    margin: -15px -15px -15px 0;\n    letter-spacing: 1.65px;\n    &:hover {\n      border: none;\n      background-color: transparent;\n    }\n  }\n"])), function (_ref) {
  var $type = _ref.$type;
  return $type === 'success' ? _const.Colors.success : _const.Colors.begonia;
}, _const.Colors.white, _const.TextSize.sm, _const.Colors.white, _const.TextSize.xxs);
exports.NotificationStyled = NotificationStyled;